import {DomainObject} from 'shared/store';
import {observable} from 'mobx';

class CompanyInsuranceCarrier extends DomainObject {
  @observable name;
  @observable company;
  @observable upcomingRenewalDate;
  @observable selfAssignedCertificatesEnabled;
  @observable tpa;
  @observable dataFeedEnabled;
}

export default CompanyInsuranceCarrier;
